import moment from 'moment';

export class TrialService {
	public canEditProductTrial($auth: any, trialEndsDate: string | null): boolean {
		if (trialEndsDate == null || trialEndsDate.trim().length === 0) return true;
		try {
			const difference = moment.utc(trialEndsDate).diff(moment.now(), 'months', true);
			return difference < 1 || $auth.user().super;
		} catch (e) {
			return false;
		}
	}
}
